import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this.clickOutsideHandler = this.closeOnClickOutside.bind(this);
    document.addEventListener("click", this.clickOutsideHandler);

    this.escapeHandler = this.closeOnEscape.bind(this);
    document.addEventListener("keydown", this.escapeHandler);
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutsideHandler);
    document.removeEventListener("keydown", this.escapeHandler);
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    this.menuTarget.classList.toggle("hidden");
  }

  close() {
    this.menuTarget.classList.add("hidden");
  }

  closeOnClickOutside(event) {
    if (
      this.element.contains(event.target) &&
      event.target.closest("[data-action*='dropdown#toggle']")
    ) {
      return;
    }

    if (
      this.menuTarget &&
      this.menuTarget.classList.contains("hidden") === false &&
      !this.menuTarget.contains(event.target)
    ) {
      this.close();
    }
  }

  closeOnEscape(event) {
    if (
      event.key === "Escape" &&
      !this.menuTarget.classList.contains("hidden")
    ) {
      this.close();
    }
  }
}
